import React from 'react';
import BaseCreatePage from '../../_CustomComponents/BaseCreatePage';
import { connect } from "react-redux";
import { addDays, addYears } from 'date-fns';
import BiDynamicForm from '../../../../partials/layout/BiDynamicForm';
import * as programCrud from '../../../../crud/program.crud';
import { Portlet, PortletBody, PortletHeader } from "../../../../partials/content/Portlet";
import { Alert } from "react-bootstrap";
import moment from 'moment';
import { FormattedMessage } from "react-intl";
import { withCreatePageProps } from '../../../../shared/hoc/withCreatePageProps';
import Common from '../../../../shared/common';
import { actionCodes } from "../../../../shared/lookup";
class ProgrammeCreate extends BaseCreatePage {
    constructor(props) {
        super(props);
        const { subject } = ((props.location.state || {}).itemCustomProps || {});
        //if it's coming from create new via Clause/Type button, try to set default clause display value according to the clauseDisplay passed in location state from clause dropdown
        const { clauseDisplay } = (((props.location || {}).state || {}).itemCustomProps || {});

        const createFormConfig = this.getFormConfig(subject, clauseDisplay);
        this.state = {
            showAlert: true,
            createFormConfig
        };
    }
    getFormConfig = (subject, clauseDisplay) => {
        const { contract } = this.props;
        const { fields } = this.props.workflowItem;
        const createFormConfig = {
            buttonResource: "GENERAL.FORMS.BUTTON_CREATE_DRAFT",
            fields: [
                { label: fields.Reference.label, dataField: 'reference', editorOptions: { defaultValue: subject } },

            ]
        };
        if (fields.Type.visible) {
            const typeField = {
                label: fields.Type.label,
                dataField: 'type',
                editorType: 'dxSelectBox',
                editorOptions: { dataSource: fields.Type.clauses, valueExpr: 'display', displayExpr: 'display', defaultValue: clauseDisplay }
            };
            //IF THERE IS ONLY ONE ITEM
            //PRE_SELECT & NON-EDITABLE
            if (fields.Type.clauses?.length === 1) {
                typeField.editorOptions.defaultValue = fields.Type.clauses[0].display;
            }
            createFormConfig.fields.push(typeField)
        }
        if (fields.PreviousPlanned.visible && contract.expectedcompletiondate) {
            createFormConfig.fields.push({ label: fields.PreviousPlanned.label, dataField: 'previousplanneddatedisplay', editorType: 'dxDateBox', editorOptions: { readOnly: true, value: new Date(contract.expectedcompletiondate) } })
        }
        if (fields.PlannedCompletion.visible) {
            createFormConfig.fields.push({ label: fields.PlannedCompletion.label, dataField: 'plannedcompletiondatedisplay', editorType: 'dxDateBox', validation: { type: 'range', min: new Date(1900, 0, 1), max: new Date(2079, 5, 6), warning: this.props.intl.formatMessage({ id: "GENERAL.FORMS.INVALID_DATE" }) } })
        }
        if (fields.Reason.visible) {
            createFormConfig.fields.push({ label: fields.Reason.label, dataField: 'reasonchanged', editorType: 'dxHtmlEditor' })
        }
        if (fields.Change.visible) {
            createFormConfig.fields.push({ label: fields.Change.label, dataField: 'details', editorType: 'dxHtmlEditor' })
        }
        if (fields.MainProgress.visible) {
            createFormConfig.fields.push({ label: fields.MainProgress.label, dataField: 'mainprogress', editorType: 'dxHtmlEditor' })
        }
        if (fields.KeyActivities.visible) {
            createFormConfig.fields.push({ label: fields.KeyActivities.label, dataField: 'keyactivities', editorType: 'dxHtmlEditor' })
        }
        if (fields.Summary.visible) {
            createFormConfig.fields.push({ label: fields.Summary.label, dataField: 'summarycritical', editorType: 'dxHtmlEditor' })
        }
        if (fields.Changes.visible) {
            createFormConfig.fields.push({ label: fields.Changes.label, dataField: 'mainchanges', editorType: 'dxHtmlEditor' })
        }
        if (fields.Compensation.visible) {
            createFormConfig.fields.push({ label: fields.Compensation.label, dataField: 'compensationevents', editorType: 'dxHtmlEditor' })
        }
        return createFormConfig;
    }
    submitHandler = (program, setSubmitting) => {
        const { fields } = this.props.workflowItem;
        program.companyid = this.props.contract.companyid;
        program.contractid = this.props.contract.contractid;
        program.projectid = this.props.contract.projectid;
        if (fields.PlannedCompletion.visible) {
            program.plannedcompletiondatedisplay = moment(program.plannedcompletiondatedisplay).format('DD/MM/YYYY');
        }
        // program.changeddatedisplay = moment().format('DD/MM/YYYY');
        if (fields.PreviousPlanned.visible && this.props.contract.expectedcompletiondate) {
            program.previousplanneddatedisplay = moment(new Date(this.props.contract.expectedcompletiondate)).format('DD/MM/YYYY');
        }
        program.status = 'Not Communicated';
        program.isreplyrequired = false;
        program.actioncode = actionCodes.CREATE;
        program.workflowid = this.props.workflowItem.id;
        this.appendRelationship(program);
        Common.PropertyConversionsBeforeNoticeSaveRequest(program, this.props.customFields, this.props.contractUsers);
        programCrud.saveContractProgram(program)
            .then(response => {
                this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'GENERAL.COMMUNICATON.DRAFT_SUCCESS' }), { variant: 'success', });
                try {
                    const createdID = Number(response.data);
                    this.props.navigate(this.props.workflowItem.paths.basePath + createdID);
                }
                catch {
                    this.props.navigate(this.props.workflowItem.paths.listPath);
                }
            })
            .catch(err => {
                this.props.enqueueSnackbar(err.toString(), { variant: 'error', key: "PersistentFormWarning", persist: true });
            });

    }

    render() {

        const { assetid } = ((this.props.location.state || {}).itemCustomProps || {});
        return (
            <Portlet>
                <PortletHeader title={this.props.intl.formatMessage({ id: 'GENERAL.FORMS.CREATE_TITLE' }, { ITEM_NAME: this.props.workflowItem.pageTitle })} />
                <PortletBody style={{ maxWidth: 1000 }}>
                    {this.state.showAlert && (
                        <Alert variant="secondary" onClose={() => this.setState({ showAlert: false })} dismissible>
                            <p>
                                <FormattedMessage id="GENERAL.FORMS.WARNING_DRAFT" />
                            </p>
                        </Alert>
                    )}
                    <BiDynamicForm
                        config={this.state.createFormConfig}
                        onSubmitHandler={this.submitHandler}
                        customFields={(this.props.customFields || {}).COMMUNICATION}
                        assetFieldsEnabled={this.props.workflowItem.assetFieldsEnabled}
                        assetid={assetid}
                    />
                </PortletBody>
            </Portlet>
        );
    }
}

const mapStateToProps = store => ({
    contractUsers: store.contract.users
});

export default withCreatePageProps(connect(mapStateToProps)(ProgrammeCreate));
